/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Image, Space } from "antd";
import { TableCell, TableRow } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import clsx from "clsx";
import { getColumnWidth, checkCRUDPermission, idNamingConversion } from "../../../../../helpers/utilities";
import { Link } from "react-router-dom";
import { customerProductsHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import SearchText from '../../../../Shared/components/SearchText';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { AESEncrypt } from "../../../../../helpers/Crypto";

export const CustomTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy,
        loadMore, handleOpen, loadMoreContent, loadMoreTask, search, roleManagement } = props;


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={customerProductsHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={customerProductsHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                                <TableCell style={{ width: getColumnWidth(customerProductsHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Customer Products', 'view', 'Sales') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'customerProducts', 'Link')} to={`/sales/setup/customer-products/${AESEncrypt({ 'customerId': data.id, 'customerName': data.name, 'mobile': data.mobile, 'email': data.email })}/view`}
                                                                className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.disBlock, classes.bold)}>
                                                                {data?.name}
                                                            </Link> : data?.name
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerProductsHead, 1) }}><span style={{ width: "100%", whiteSpace: "break-spaces", lineHeight: 1.5 }}>{data?.serialNumber || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerProductsHead, 2) }}><span style={{ width: "100%", whiteSpace: "break-spaces", lineHeight: 1.5 }}>{data?.count || '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Products', 'view', 'Sales') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'customerProducts', 'Icon')} to={`/sales/setup/customer-products/${AESEncrypt({ 'customerId': data.id, 'customerName': data.name, 'mobile': data.mobile, 'email': data.email })}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Products', 'edit', 'Sales') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'customerProducts', 'Icon')} to={`/sales/setup/customer-products/${AESEncrypt({ 'customerId': data.id, 'customerName': data.name, 'mobile': data.mobile, 'email': data.email })}/edit`}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </Link>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={customerProductsHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> : <>
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by your Customer Products'}</p>
                                                            <div className={classes.margin20t}>
                                                                <Link
                                                                    id={idNamingConversion('Create Customer Group', 'customerProducts', 'Link')}
                                                                    style={{ display: "inline-block" }}
                                                                    to={`/sales/setup/customer-products/create`}
                                                                    onClick={() => handleOpen()}
                                                                    className={clsx(classes.modalBtn)}>Create Customer Group</Link>
                                                            </div>
                                                        </>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}
